
export default {
  name: 'Header',
  data: () => ({
    hideMenu: false,
  }),
  computed: {
    isMenuOpen() {
      return this.$store.getters['navigation/overlayStatus']
    },
    scroll() {
      return this.$store.getters['app/scroll']
    },
  },
  watch: {
    '$store.state.app.scroll': {
      handler(val, oldVal) {
        const menuHeight = this.$refs.header.getBoundingClientRect().height
        if (val.y >= oldVal.y && val.y > menuHeight) {
          this.hideMenu = true
        } else {
          this.hideMenu = false
        }
      },
    },
  },
}
